import { render, staticRenderFns } from "./ResultSegment.vue?vue&type=template&id=f1ccdc5e&"
import script from "./ResultSegment.vue?vue&type=script&lang=js&"
export * from "./ResultSegment.vue?vue&type=script&lang=js&"
import style0 from "./ResultSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports